export const storageChaptersKey: string = 'completedChapters';